export enum DamageCostLimit {
	Ok = 'Ok',
	MehrAlsKostengrenzeEins = 'MehrAlsKostengrenzeEins',
	MehrAlsKostengrenzeZwei = 'MehrAlsKostengrenzeZwei'
}
